import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification, Radio} from 'antd';

import {getDiscountReason, updateDiscountReason} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateDiscountReasonForm extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    discountReason: PropTypes.object.isRequired,
    /* actions */
    getDiscountReason: PropTypes.func.isRequired,
    updateDiscountReason: PropTypes.func.isRequired
  };

  componentDidMount() {
    this._loadDiscountReason();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.discountReasonId !== this.props.match.params.discountReasonId) {
      this._loadDiscountReason();
    }
  }

  _loadDiscountReason = () => {
    const {discountReasonId} = decodeParams(this.props.match.params);
    this.props.getDiscountReason({discountReasonId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {discountReasonId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateDiscountReason({...values, discountReasonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {discountReason, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, defaultRate, defaultRateType} = discountReason;
    return (
      <Card title="Update Discount Reason">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Default Rate"
          >
            {getFieldDecorator('defaultRate', {
              initialValue: defaultRate,
              rules: [{
                required: true,
                message: 'Default rate is required'
              }]
            })(
              <InputNumber precision={2} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Default Rate Type"
          >
            {getFieldDecorator('defaultRateType', {
              initialValue: defaultRateType,
              rules: [{
                required: true,
                message: 'Default rate type is required'
              }]
            })(
              <Radio.Group>
                <Radio.Button value="percentage">%</Radio.Button>
                <Radio.Button value="flat">$</Radio.Button>
              </Radio.Group>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Discount Reason
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateDiscountReasonPage = Form.create()(UpdateDiscountReasonForm);

const mapStateToProps = state => ({
  loading: state.discountReason.discountReasonLoading || state.discountReason.updatingDiscountReason,
  discountReason: state.discountReason.discountReason || {}
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getDiscountReason,
  updateDiscountReason,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDiscountReasonPage);



// WEBPACK FOOTER //
// ./src/DiscountReason/UpdateDiscountReasonPage.js